import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as debug from 'debug';
import * as $ from 'jquery';
import * as _ from 'lodash';

@Pipe({
  name: 'articleContent',
})
export class ArticleContentPipe implements PipeTransform {
  log = debug('app:Pipetransform');

  constructor(private domSanitizer: DomSanitizer) {}

  //remove final reference - The post <a rel="nofollow" href="https://cdllife.com/2018/video-tesla-driver-says-rear-ended-texting-trucker/">VIDEO: Tesla driver says he was rear-ended by texting trucker</a> appeared first on <a rel="nofollow" href="https://cdllife.com">CDLLife</a>.</p

  transform(html: string, ...args): SafeHtml {
    const domElement = $('<div></div>').html(html);

    this.removeUnnecessaryAttributions(domElement);
    this.removeCustomWidthAndHeights(domElement);
    this.removeEmptyPs(domElement);
    this.insertAds(domElement);

    return this.domSanitizer.bypassSecurityTrustHtml(domElement.html());
  }

  insertAds(domElement) {
    const ad = $(`
          <div class='Ad is-hidden'>
          </div>
        `);

    const third = $(domElement)
      .find('p, img, .NewsPostContent-embed')
      .eq(3);

    if (third) {
      ad.insertAfter(third);
    } else {
      domElement.append(ad);
    }
  }

  removeEmptyPs(domElement) {
    $(domElement)
      .find('p')
      .each(function() {
        const html = String($(this).html() || '').replace(/[&]nbsp;/g, '');
        if (!html) {
          $(this).remove();
        }
      });
  }

  removeCustomWidthAndHeights(domElement) {
    $(domElement)
      .find('img')
      .each(function() {
        $(this).attr('width', null);
        $(this).attr('height', null);
        $(this).addClass('inArticle');

        $(this).attr('src', $(this).attr('src'));
        if (
          !$(this)
            .parent()
            .hasClass('.NewsPostContent')
        ) {
          $(this)
            .parent()
            .addClass('no-padding');
        }
      });

    $(domElement)
      .find('iframe')
      .each(function() {
        const h = $(this).attr('height'),
          w = $(this).attr('width'),
          wrap = $('<div class="NewsPostContent-embed"></div>'),
          src = $(this).attr('src');

        if (/amazon-adsystem/.test(src)) {
          $('<br/><br/>').insertAfter(this);
          $(this).remove();
          return;
        }

        $(this).addClass('inArticle');
        $(this).attr('src', fixSrc(src));

        if (
          !$(this)
            .parent()
            .hasClass('.NewsPostContent')
        ) {
          $(this)
            .parent()
            .addClass('no-padding');
        }

        if (h && w) {
          let padding = _.round((h / w) * 100, 2);

          // some custom logic
          if (/video\.php/i.test(src) && /facebook/i.test(src)) {
            // we don't want videos shorter than 16:9
            padding = Math.max(56.25, padding);
          }

          $(wrap).css({
            'padding-bottom': `
              calc(${padding}% + 30px)
            `.trim(),
          });
        }

        $(this).wrap(wrap);
        $(this).attr('width', null);
        $(this).attr('height', null);
      });

    function fixSrc(src) {
      if (/^\/\//.test(src)) {
        const protocol = location.protocol;

        if (/file/.test(location.protocol)) {
          return 'http:' + src;
        }
      } else {
        return src;
      }
    }
  }

  removeUnnecessaryAttributions(domElement) {
    $(domElement)
      .find('a[rel="nofollow"]')
      .each(function() {
        const href = $(this).attr('href');
        if (/cdllife.com/i.test(href)) {
          $(this)
            .parent()
            .remove();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/article-content/article-content.ts